import gsap from 'gsap';

const $mainPageContent = document.querySelector('.main-page-content');

const successPageAnimate = () => {
  console.log('I did it, yay')
  gsap.to( $mainPageContent , 0.3,  {
    opacity: 0,
    ease: 'power4.out',
  })
  gsap.to( '#bgFadeIn' , 0.5, {
    opacity: 0,
    ease: 'power1.in',
  })
  gsap.to( '.app-wrapper' , 0.5, {
    opacity: 0,
    ease: 'power1.in',
    onComplete: () => {
      window.location.pathname = '/thank-you';
    },
  })
}

export default successPageAnimate;



// WEBPACK FOOTER //
// ./scripts/components/successPageAnimate.js